import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import CollapseBlock from '../blocks/CollapseBlock/CollapseBlock';
import { Radio, Badge, Flex } from 'antd';

const TableFilter = ({
  title,
  storageKey,
  value,
  setValue,
  options, // [{value: string, label: string, count?: number}]
}) => {
  const { t } = useTranslation();
  const localStorageKey = storageKey || title;

  return (
    <CollapseBlock collapsible={true} title={t(title)}>
      <Flex style={{ alignItems: 'baseline' }} gap="middle">
        <Radio.Group
          value={value}
          onChange={(e) => {
            const value = e.target.value;
            localStorage.setItem(localStorageKey, value);
            setValue(value);
          }}
          style={{ whiteSpace: 'nowrap' }}
        >
          {options.map((option) => (
            <Radio.Button key={option.value} value={option.value}>
              {t(option.label)}
              {option.count !== undefined && option.count !== null && (
                <Badge
                  count={option.count}
                  showZero
                  size="small"
                  overflowCount={99}
                  offset={[5, -15]}
                  style={{ marginLeft: 0 }}
                  color={option.count ? 'orange' : 'green'}
                />
              )}
            </Radio.Button>
          ))}
        </Radio.Group>
      </Flex>
    </CollapseBlock>
  );
};

TableFilter.propTypes = {
  setValue: PropTypes.func.isRequired,
  storageKey: PropTypes.string,
  title: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
};

export default TableFilter;
